// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { PartecipataServizioDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class PartecipataServizioApiClient extends BaseCRUDApiClient<PartecipataServizioDto> {
  baseUrl = this.config.apiEndpoint + '/partecipata-servizio';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
